import React, { createContext, useCallback, useContext, useState } from "react";
import { StyleSheet } from "react-native";
import { adaptLayoutStyles } from "../shared/layout-model.js";
import {resolveCustomerAppearance, validAppearancePatch} from '../shared/appearance-model.js';
import type {Appearance} from '../shared/appearance-types';
export type LayoutKey = "simple" | "modern" | "technical" | "modern2" | "accessible";
const defaults=resolveCustomerAppearance(null) as Appearance;
const Context=createContext({layout:'modern2' as LayoutKey,appearance:defaults,selectAppearance(_patch:Partial<Appearance>) {}});
function initial():Appearance {
  try {
    const raw=globalThis.localStorage?.getItem('qsmart.appearance');
    const language=globalThis.localStorage?.getItem('qsmart.language');
    return resolveCustomerAppearance(raw?JSON.parse(raw):{layout:globalThis.localStorage?.getItem('qsmart.layout')??globalThis.localStorage?.getItem('qsmart-layout')},language==='en-GB'?'en-GB':'da-DK') as Appearance;
  } catch {return defaults;}
}
export function LayoutProvider({ children }: { children: React.ReactNode }) {
  const [appearance, setAppearance] = useState<Appearance>(initial);
  const selectAppearance = useCallback((patch:Partial<Appearance>) => {
    if(validAppearancePatch(patch))setAppearance(previous=>resolveCustomerAppearance({...previous,...patch}) as Appearance);
  }, []);
  return <Context.Provider value={{ layout:'modern2', appearance, selectAppearance }}>{children}</Context.Provider>;
}
export const useLayout = () => useContext(Context);
export function useDesignStyles() {
  const {appearance:{textSize}}=useLayout();
  return useCallback(<T extends StyleSheet.NamedStyles<T>>(sheet:T):T=>{
    const canonical=adaptLayoutStyles(sheet,'modern2');
    return StyleSheet.create(canonical as T);
  },[textSize]);
}
